import React from 'react';

const Logo = ({ size = 'normal' }) => {
  const logoUrl = 'https://customer-assets.emergentagent.com/job_e81f5d80-c959-49a9-880e-82b653626a65/artifacts/lb4f0eci_logo%2002%20png%20transpernet.jpg';
  const sizeClasses = {
    normal: 'h-10',
    large: 'h-16',
    xlarge: 'h-32'
  };
  const sizeClass = sizeClasses[size] || sizeClasses.normal;
  return <img src={logoUrl} alt="CIVOTE" className={sizeClass} />;
};

export default Logo;
